(() => {
  'use strict';

  document.addEventListener('DOMContentLoaded', () => {
    if (window.location.pathname !== '/pages/book-a-tour') {
      return;
    }

    if (window.bookTourViewItemListFired) {
      return;
    }

    const mainContent = document.querySelector('#MainContent');
    if (!mainContent) {
      return;
    }

    window.dataLayer = window.dataLayer || [];

    /** @type {Array<{
     *  item_id: string,
     *  item_name: string,
     *  quantity: number,
     *  price: number,
     *  affiliation: string,
     *  coupon: (string|undefined),
     *  discount: (number|undefined),
     *  index: number,
     *  item_brand: string,
     *  item_category: string,
     *  item_category2: (string|undefined),
     *  item_category3: (string|undefined),
     *  item_category4: (string|undefined),
     *  item_category5: (string|undefined),
     *  item_list_id: string,
     *  item_list_name: string,
     *  item_variant: (string|undefined),
     *  location_id: (string|undefined)
     * }>} */
    const items = [];

    const sections = mainContent.querySelectorAll('.shopify-section');

    sections.forEach((section) => {
      const heading = section.querySelector('h2');
      const image = section.querySelector('img');
      const groupBlockContent = section.querySelector('.group-block-content');

      if (!heading || !image || !groupBlockContent) {
        return;
      }

      const itemName = heading.textContent?.trim();

      if (!itemName) {
        return;
      }

      const itemIndex = items.length;

      items.push({
        item_id: `tour-${itemIndex + 1}`,
        item_name: itemName,
        quantity: 1,
        price: 0,
        affiliation: 'Tours',
        coupon: undefined,
        discount: undefined,
        index: itemIndex,
        item_brand: 'Bundaberg',
        item_category: 'Tours',
        item_category2: undefined,
        item_category3: undefined,
        item_category4: undefined,
        item_category5: undefined,
        item_list_id: 'book-a-tour',
        item_list_name: 'Book a Tour',
        item_variant: undefined,
        location_id: undefined,
      });

      const button = [...section.querySelectorAll('a')].find((a) => a.textContent?.trim().toUpperCase() === 'BOOK NOW');

      if (button && button.dataset.selectItemBound !== 'true') {
        button.dataset.selectItemBound = 'true';

        button?.addEventListener('click', () => {
          window.dataLayer.push({
            event: 'select_item',
            select_item_type: 'Tours',
            timestamp: Date.now(),
            _clear: true,
            ecommerce: {
              currency: 'AUD',
              value: 0,
              items: [items[itemIndex]],
            },
          });
        });
      }
    });

    if (!items.length) {
      console.warn('[Analytics] No tour items found.');
      return;
    }

    /** @returns {void} */
    function fireViewItemList() {
      if (window.bookTourViewItemListFired) {
        return;
      }

      window.bookTourViewItemListFired = true;

      window.dataLayer.push({
        event: 'view_item_list',
        item_list_type: 'Product',
        timestamp: Date.now(),
        _clear: true,
        ecommerce: {
          currency: 'AUD',
          value: 0,
          items,
        },
      });

      console.log('[Analytics] Book a Tour view_item_list fired.', items);
    }

    /** @returns {void} */
    function waitForPageView() {
      window.dataLayer = window.dataLayer || [];

      const hasPageView = window.dataLayer.some((dlEvent) => dlEvent.event === 'page_view');

      if (hasPageView) {
        fireViewItemList();
      } else {
        setTimeout(waitForPageView, 50);
      }
    }

    waitForPageView();
  });
})();
